@if (hasChanged) {
  <p class="not-saved-block">Изменения не сохранены</p>
}

@if (IsSelected) {
  <div class="input-wrap" (click)="$event.stopPropagation()">
    <label class="f-title">Ссылка на видео с YouTube/RuTube/VKVideo</label>
    <textarea class="form-input" (ngModelChange)="onChangeLink($event)" [ngModel]="getVideoLink()"
    placeholder="https://www.youtube.com/watch?v= ... или https://rutube.ru/video/... или https://vkvideo.ru/..."></textarea>
    @if (!isValidRegex(ItemData)) {
      <p class="invalid-link">Неправильная ссылка</p>
    }
    <div class="buttons">
      <div class="button" (click)="changeText()">Сохранить</div>
    </div>
    @if (ItemData) {
      <div class="video-wrap" [innerHTML]="this.ItemData|videoframePipe|safe"></div>
    }
  </div>
}

@if (!IsSelected) {
  <div class="input-wrap">
    @if (ItemData) {
      <div class="video-wrap" [innerHTML]="this.ItemData|videoframePipe|safe"></div>
    }
    @if (!ItemData) {
      <div class="no-video">
        <p class="f-text" style="text-align:center">Нет видео</p>
      </div>
    }
  </div>
}
